import { createHighlightingRule } from "views/logic/slices/highlightActions";
import { selectHighlightingRules } from "views/logic/slices/highlightSelectors";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
const HighlightValueHandler = ({ field, value }) => (dispatch) => {
  if (value === void 0) {
    return Promise.reject(new Error("Unable to add highlighting for missing value."));
  }
  return dispatch(createHighlightingRule(field, value));
};
const isEnabled = ({ field, value, contexts }, getState) => {
  const highlightingRules = selectHighlightingRules(getState());
  return !hasMultipleValueForActions(contexts) && highlightingRules.find(({ field: f, value: v }) => field === f && value === v) === void 0;
};
HighlightValueHandler.isEnabled = isEnabled;
export default HighlightValueHandler;
